import common from "./common.json";
import dashboard from "./dashboard.json";
import fallback from "./fallback.json";
import pages from "./pages.json";
import sys from "./sys.json";

export default {
  ...common,
  ...dashboard,
  ...fallback,
  ...sys,
  ...pages,
};
